import React, { useCallback, useEffect, useState } from 'react';
import cogoToast from 'cogo-toast';

import {
  SbatGroupSuperBatches,
  useDeleteSuperBatchAcademyTopicMutation,
} from 'features/classCreation';
import CreateSuperBatchAcademyTopicModal from '../CreateSuperBatchAcademyTopicModal';
import ToggleChip from 'components/ToggleChip';

export default function EditSbatGroupSuperBatchesForm({
  isEditing,
  setIsEditing,
  sbatGroup,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteSuperBatchAcademyTopic, { isSuccess, error }] =
    useDeleteSuperBatchAcademyTopicMutation();

  const handleModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Detached class successfully for selected batch!');
      setIsEditing(false);
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in detaching this super batch. Please try again later!'
      );
    }
  }, [error, isSuccess, setIsEditing]);

  const handleSuperBatchDelete = useCallback(
    (superBatchAcademyTopicId) => {
      if (
        window.confirm('Are you sure, you want to detach this super batch?')
      ) {
        deleteSuperBatchAcademyTopic({
          superBatchAcademyTopicId,
          sbatGroupId: sbatGroup.id,
        });
      }
    },
    [deleteSuperBatchAcademyTopic, sbatGroup.id]
  );

  if (isEditing) {
    return (
      <>
        <CreateSuperBatchAcademyTopicModal
          handleClose={handleModalClose}
          sbatGroup={sbatGroup}
          isOpen={modalOpen}
        />
        {sbatGroup.super_batch_academy_topics.map((sbat) => (
          <ToggleChip
            isAdded
            onRemove={() => handleSuperBatchDelete(sbat.id)}
            label={sbat.super_batch.name}
            className="m-r-xs m-b-xxs"
            key={sbat.id}
          />
        ))}
        <ToggleChip
          onAdd={handleModalOpen}
          label="Add new batch"
          className="m-r-xs m-b-xxs"
        />
      </>
    );
  } else {
    return <SbatGroupSuperBatches sbatGroup={sbatGroup} />;
  }
}
